import { Theme, createStyles } from '@material-ui/core';

const styles = ({
  palette: {
    primary,
    common: { white },
  },
  typography: { fontFamily },
  custom: {
    fontSizes: { small, subHeading },
    palette: { colorSupportSteel },
  },
  spacing: { unit },
}: Theme) =>
  createStyles({
    wrapper: {
      marginBottom: `${unit * 3}px`,
    },
    titleWrapper: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      height: 50,
    },
    title: {
      color: primary.main,
      fontWeight: 600,
      fontSize: subHeading,
      padding: 0,
      display: 'inline-block',
      marginBottom: `${unit + 2}px`,
    },
    labelInfoWrapper: {
      backgroundColor: colorSupportSteel,
      padding: `${unit / 2}px ${unit}px`,
      width: 256,
      height: 44,
      borderRadius: 3,
      lineHeight: 1.25,
      marginLeft: `${unit}px`,
    },
    labelInfoText: {
      fontFamily,
      fontSize: small,
      color: white,
      fontStyle: 'normal',
      fontWeight: 'normal',
    },
    content: {
      display: 'inline-block',
      width: '100%',
    },
  });

export default styles;
